import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  SettingsResponseSchema,
  type Settings,
} from '../shared/schemas/settings.js';

export const getSettings = defaultClient.query({
  url: 'omni-trafficking/v1/settings/',
  method: 'GET',
  responseSchema: SettingsResponseSchema,
  processResponse(data) {
    return data.data?.items[0] || null;
  },
  querySchema: z.object({
    activityId: z.string(),
  }),
  snakeCaseQueryParams: true,
});

// TODO: should we rename to createSettings? POST?
export const updateSettings = defaultClient.mutation({
  url: 'omni-trafficking/v1/settings/' as const,
  method: 'POST',
  responseSchema: SettingsResponseSchema,
  processResponse(data) {
    return data;
  },
  requestSchema: z.object({
    activityId: z.string(),
    integrationId: z.string(),
  }),
  onSuccess(queryClient, data, variables) {
    queryClient.setQueryData(
      getSettings.queryKey.dataTag({
        params: { activityId: variables.data.activityId },
      }),
      data.data?.items[0] || null,
    );
  },
});

export const patchSettingNamingConvention = defaultClient.mutation({
  url: 'omni-trafficking/v1/settings/$settingsId/' as const,
  method: 'PATCH',
  responseSchema: SettingsResponseSchema,
  processResponse(data) {
    return data.data?.items[0] || null;
  },
  requestSchema: z.object({
    namingConventionId: z.string(),
  }),
});

export type SettingsResponse = z.infer<typeof SettingsResponseSchema>;

export type Settings = z.infer<typeof Settings>;
